import { useState } from 'react'

export default function InfoTip({ text }: { text: string }) {
  const [open, setOpen] = useState(false)
  return (
    <span className="relative inline-block align-middle">
      <button
        type="button"
        aria-label="More information"
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
        onBlur={() => setOpen(false)}
        className="ml-1 inline-flex h-4 w-4 items-center justify-center rounded-full border border-border text-[10px] font-semibold leading-none text-text-subtle hover:border-brand hover:text-brand-text"
      >
        i
      </button>
      {open && (
        <span
          role="tooltip"
          className="absolute left-1/2 top-6 z-20 w-60 -translate-x-1/2 rounded-md border border-border bg-surface p-2 text-xs font-normal leading-snug text-text-muted shadow-md"
        >
          {text}
        </span>
      )}
    </span>
  )
}
